"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../models");
var localization_1 = require("../localization");
exports.displayDateTrunc = function (dateTrunc) {
    // tslint:disable-next-line: switch-default
    switch (dateTrunc) {
        case models_1.DateTrunc.YEAR:
            return localization_1.Messages.metricsDateTruncYear();
        case models_1.DateTrunc.QUARTER:
            return localization_1.Messages.metricsDateTruncQuarter();
        case models_1.DateTrunc.MONTH:
            return localization_1.Messages.metricsDateTruncMonth();
        case models_1.DateTrunc.DAY:
            return localization_1.Messages.metricsDateTruncDay();
        case models_1.DateTrunc.HOUR:
            return localization_1.Messages.metricsDateTruncHour();
        case models_1.DateTrunc.MINUTE:
            return localization_1.Messages.metricsDateTruncMinute();
        case models_1.DateTrunc.SECOND:
            return localization_1.Messages.metricsDateTruncSecond();
        case models_1.DateTrunc.WEEK:
            return localization_1.Messages.metricsDateTruncWeek();
        case models_1.DateTrunc.ISO_YEAR:
            return localization_1.Messages.metricsDateTruncISOYear();
        case models_1.DateTrunc.ISO_QTR:
            return localization_1.Messages.metricsDateTruncISOQuarter();
        case models_1.DateTrunc.ISO_WEEK:
            return localization_1.Messages.metricsDateTruncISOWeek();
        case models_1.DateTrunc.ISO_WEEKDAY:
            return localization_1.Messages.metricsDateTruncISOWeekday();
        case models_1.DateTrunc.UNKNOWN:
            return '';
    }
    return '';
};
//# sourceMappingURL=dateFormatter.js.map